export const JOB_EMPLOYMENT_STATUS = [
  {
    id: 0,
    label: 'Full Time',
    value: 'Full-time',
  },
  {
    id: 1,
    label: 'Part Time',
    value: 'Part-time',
  },
  {
    id: 2,
    label: 'Unemployed',
    value: 'Unemployed',
  },
];

export const JOB_OPPORTUNITY_TYPE = [
  {
    id: 0,
    label: 'Full-time',
    title: 'Full Time',
    required: false,
  },
  {
    id: 2,
    label: 'Part-time',
    title: 'Part Time',
    required: false,
  },
  {
    id: 1,
    label: 'Internship',
    title: 'Internship',
    required: false,
  },
  {
    id: 3,
    label: 'No Preference',
    title: 'No Preference',
    required: false,
  },
];

export const JOB_WORK_PREFERENCE = [
  {
    id: 0,
    label: 'Remote',
    title: 'Remote',
    required: false,
  },
  {
    id: 1,
    label: 'In-person',
    title: 'In Person',
    required: false,
  },
  {
    id: 2,
    label: 'Hybrid',
    title: 'Hybrid',
    required: false,
  },
  {
    id: 3,
    label: 'No Preference',
    title: 'No Preference',
    required: false,
  },
];

export const SELECTED_WORK_FLEXIBILITY = [
  {
    id: 0,
    label: 'Flexible hours',
    title: 'Flexible Hours',
    required: false,
  },
  {
    id: 1,
    label: 'Telecommuting',
    title: 'Telecommuting',
    required: false,
  },
  {
    id: 2,
    label: 'Job Sharing',
    title: 'Job Sharing',
    required: false,
  },
  {
    id: 3,
    label: 'Part-time',
    title: 'Part Time',
    required: false,
  },
  {
    id: 4,
    label: 'Alternative Work Weeks',
    title: 'Alternative Work Weeks',
    required: false,
  },
];

export const SELECTED_COMMUTE_OPTIONS = [
  {
    id: 0,
    label: '25mi',
    title: 'Less than 25mi',
    required: false,
  },
  {
    id: 1,
    label: '25-50mi',
    title: '25-50mi',
    required: false,
  },
  {
    id: 2,
    label: '50-100mi',
    title: '50-100mi',
    required: false,
  },
  {
    id: 3,
    label: 'relocate',
    title: 'Willing to Relocate',
    required: false,
  },
];

export const SELECTED_TRAVEL_OPTIONS = [
  {
    id: 0,
    label: 'none',
    title: 'None',
    required: false,
  },
  {
    id: 1,
    label: '10%',
    title: 'Less than 10%',
    required: false,
  },
  {
    id: 2,
    label: '10%-25',
    title: '10%-25%',
    required: false,
  },
  {
    id: 3,
    label: '25%-50%',
    title: '25%-50%',
    required: false,
  },
  {
    id: 4,
    label: '50%',
    title: 'More than 50%',
    required: false,
  },
  {
    id: 5,
    label: 'international',
    title: 'No International Travel',
    required: false,
  },
];
